import * as model from "@/model/master/processConf/ProcessMaterial";
import { newEntityStoreHelper } from "@/store/common/entityModule";
import router from "@/router";
import _ from 'lodash';


function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

const baseStore = newEntityStoreHelper(() => new model.ProcessMaterial(), newFilter).buildStore();

function date2str(date) {
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  return `${year}-${month + 1}-${d}`;
}

function time2str(time) {
  let date = new Date;
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  let h = time.getHours();
  let m = time.getMinutes();
  let s = time.getSeconds();
  return `${year}-${month+1}-${d} ${h}:${m}:${s}`;
}

const baseUrl = process.env.VUE_APP_MASTER_API_URL + "master-service/master";

const processMaterialStore = {
  namespaced: true,
  state: {
    baseModuleUrl: baseUrl,
    currentProcessMaterial: {},
  },
  mutations: {
    setCurrentProcessMaterial(state, data) {
      state.currentProcessMaterial = data;
    },
  },
  actions: {
    jumpToEdit(context, item) {
      context.commit("processMaterial/setCurrentProcessMaterial", item, {
        root: true
      });
      router.push({
        name: "processMaterialEdit"
      });
    },
    findAll(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/processMaterial/findAll',
      }, {
          root: true,
        });
    },
    findPage(context, { index, size }) {
      const data = new FormData();
      data.append('page', index)
      data.append('size', size)

      return context.dispatch('api/post', {
        url: baseUrl + '/processMaterial/findPage',
        data,
      }, {
          root: true,
        });
    },
    deleteById(context, id) {
      const data = new FormData();
      data.append('id', id)
      return context.dispatch('api/post', {
        url: baseUrl + '/processMaterial/delete',
        data,
      }, {
          root: true,
        });
    },
    getLength(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/processMaterial/getLength',
      }, { root: true })
    },
    saveCurrentProcessMaterial(context) {
      return context.dispatch('saveProcessMaterial', context.state.currentProcessMaterial);
    },
    saveProcessMaterial(context, processMaterial) {
      let data = new FormData();
      let id = processMaterial.id > 0 ? processMaterial.id : -1;
      data.append('id', id);
      data.append('optionId', processMaterial.optionId);
      data.append('optionName', processMaterial.optionName); 

      data.append('materialId', processMaterial.materialId);      
      data.append('materialCode', processMaterial.materialCode);
      data.append('materialName', processMaterial.materialName); 
      data.append('materialType', processMaterial.materialType); 
      data.append('materialUnit', processMaterial.materialUnit); 
      data.append('materialPercent', processMaterial.materialPercent); 

      return context.dispatch('api/post', {
        url: baseUrl + '/processMaterial',
        data,
      }, {
          root: true,
        })
    }
  }
}

export default _.defaultsDeep(processMaterialStore, baseStore); // 合并 teamShiftStore 和 baseStore (冲突时选前者)